import React from 'react';
import Icon from '../../../components/AppIcon';
import { useNavigate } from 'react-router-dom';

const FooterSection = () => {
  const navigate = useNavigate();
  const currentYear = new Date()?.getFullYear();

  const quickLinks = [
    { label: 'Inicio', path: '/landing-page' },
    { label: 'Dashboard', path: '/user-dashboard' },
    { label: 'CRM', path: '/crm-lead-management' },
    { label: 'Red de Referidos', path: '/referral-network' },
    { label: 'Proyectos', path: '/project-portfolio' }
  ];

  const contactInfo = [
    {
      icon: 'Phone',
      label: 'Teléfono',
      value: '+51 954 123 456',
      link: 'tel:+51954123456'
    },
    {
      icon: 'Mail',
      label: 'Email',
      value: 'ventas@3volcanes.pe',
      link: 'mailto:ventas@3volcanes.pe'
    },
    {
      icon: 'MapPin',
      label: 'Dirección',
      value: 'Av. Principal 1234, Cercado, Arequipa',
      link: null
    }
  ];

  const socialMedia = [
    { icon: 'Facebook', label: 'Facebook', link: '#' },
    { icon: 'Instagram', label: 'Instagram', link: '#' },
    { icon: 'Linkedin', label: 'LinkedIn', link: '#' },
    { icon: 'Youtube', label: 'YouTube', link: '#' }
  ];

  const handleNavigation = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-card border-t border-border">
      <div className="px-4 md:px-6 lg:px-8 py-12 md:py-16 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-12">
          {/* Brand Column */}
          <div className="space-y-6">
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center">
                <Icon name="Mountain" size={28} color="var(--color-primary)" />
              </div>
              <div>
                <h3 className="text-xl font-heading font-bold text-foreground">
                  Residencial 3 Volcanes
                </h3>
                <p className="text-sm text-muted-foreground">
                  Millennials
                </p>
              </div>
            </div>
            <p className="text-muted-foreground leading-relaxed">
              Tu hogar ideal en Arequipa con vistas espectaculares a los volcanes Misti, 
              Chachani y Pichu Pichu. Calidad, ubicación y confianza.
            </p>
            <div className="flex gap-3">
              {socialMedia?.map((social, index) => (
                <a
                  key={index}
                  href={social?.link}
                  className="w-10 h-10 rounded-full bg-muted hover:bg-primary hover:text-primary-foreground transition-smooth flex items-center justify-center focus-ring"
                  aria-label={social?.label}
                >
                  <Icon name={social?.icon} size={20} />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links Column */}
          <div>
            <h4 className="text-lg font-heading font-semibold text-foreground mb-6">
              Enlaces Rápidos
            </h4>
            <ul className="space-y-3">
              {quickLinks?.map((link, index) => (
                <li key={index}>
                  <button
                    onClick={() => handleNavigation(link?.path)}
                    className="text-muted-foreground hover:text-primary transition-smooth flex items-center group"
                  >
                    <Icon 
                      name="ChevronRight" 
                      size={16} 
                      className="mr-2 group-hover:translate-x-1 transition-smooth" 
                    />
                    {link?.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h4 className="text-lg font-heading font-semibold text-foreground mb-6">
              Contacto
            </h4>
            <ul className="space-y-4">
              {contactInfo?.map((info, index) => (
                <li key={index} className="flex items-start space-x-3">
                  <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                    <Icon name={info?.icon} size={20} color="var(--color-primary)" />
                  </div>
                  <div>
                    <p className="text-sm text-muted-foreground mb-1">{info?.label}</p>
                    {info?.link ? (
                      <a
                        href={info?.link}
                        className="text-foreground hover:text-primary transition-smooth"
                      >
                        {info?.value}
                      </a>
                    ) : (
                      <p className="text-foreground">{info?.value}</p>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {/* Hours Column */}
          <div>
            <h4 className="text-lg font-heading font-semibold text-foreground mb-6">
              Horario de Atención
            </h4>
            <div className="space-y-4">
              <div className="p-4 rounded-xl bg-muted/50 border border-border">
                <div className="flex items-center space-x-2 mb-2">
                  <Icon name="Clock" size={20} color="var(--color-primary)" />
                  <p className="font-medium text-foreground">Lunes - Viernes</p>
                </div>
                <p className="text-muted-foreground">9:00 AM - 6:00 PM</p>
              </div>
              <div className="p-4 rounded-xl bg-muted/50 border border-border">
                <div className="flex items-center space-x-2 mb-2">
                  <Icon name="Clock" size={20} color="var(--color-primary)" />
                  <p className="font-medium text-foreground">Sábados</p>
                </div>
                <p className="text-muted-foreground">9:00 AM - 2:00 PM</p>
              </div>
              <div className="p-4 rounded-xl bg-muted/50 border border-border">
                <div className="flex items-center space-x-2 mb-2">
                  <Icon name="Clock" size={20} color="var(--color-primary)" />
                  <p className="font-medium text-foreground">Domingos</p>
                </div>
                <p className="text-muted-foreground">Cerrado</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-muted-foreground text-center md:text-left">
              © {currentYear} Residencial 3 Volcanes - Millennials. Todos los derechos reservados.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-6">
              <a href="#" className="text-sm text-muted-foreground hover:text-primary transition-smooth">
                Términos y Condiciones
              </a>
              <a href="#" className="text-sm text-muted-foreground hover:text-primary transition-smooth">
                Política de Privacidad
              </a>
              <a href="#" className="text-sm text-muted-foreground hover:text-primary transition-smooth">
                Libro de Reclamaciones
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;